/**
 * stale_close.ts · 09_APP · OS-006 · capability C40 · migration v57
 *
 * A forgotten "Done for today" is caught the next morning. Emily, 2026-10-19: "if you don't click done
 * for the day... the next time you log in, it would say, oh, we're seeing that it's the following day."
 * Her yes to the recommended shape: ask "When did you stop?", offer her last logged activity, let her
 * change it. Never book the night as work, and never assume a time when nothing else was logged.
 */

export interface StaleOpen {
  id: string;
  on_date: string;      // YYYY-MM-DD, Sacramento date the stretch belongs to
  started_at: string;
  what: string | null;
  suggested_end: string;
}

function hhmm(d: Date): string {
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/**
 * The time offered in the box. Empty when the only thing logged that day was the start itself:
 * offering the start would quietly record zero hours, which is a guess, and the rule is never guess.
 */
export function defaultStopTime(s: StaleOpen): string {
  const start = new Date(s.started_at).getTime();
  const end = new Date(s.suggested_end).getTime();
  if (!(end > start)) return "";
  return hhmm(new Date(end));
}

/** Her typed "HH:MM" on that stretch's own date, in this device's time zone (hers is Sacramento). */
export function stopAt(onDate: string, time: string): Date | null {
  const m = /^(\d{1,2}):(\d{2})$/.exec(time.trim());
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(onDate);
  if (!m || !d) return null;
  const h = Number(m[1]), min = Number(m[2]);
  if (h > 23 || min > 59) return null;
  return new Date(Number(d[1]), Number(d[2]) - 1, Number(d[3]), h, min, 0, 0);
}

/** "Sunday, October 18" for the banner. */
export function dayName(onDate: string): string {
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(onDate);
  if (!d) return onDate;
  return new Date(Number(d[1]), Number(d[2]) - 1, Number(d[3]))
    .toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
}
